import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../resetParameters";
import { createSelector } from "reselect";

const initialState = {
  headConstruction: false,
  titanSustain: false,
  totalQuantityPiles: 1,
  gwpValues: {
    steelLoadBearingMember: { standard: 0, sustain: 0 },
    rodSelection: 0,
    couplers: 0,
    centralizers: 0,
    nuts: 0,
    plate: 0,
    drillBit: 0,
    totalPerPile: 0,
    totalGWP: 0,
  },
};

const epdSlice = createSlice({
  name: "epd",
  initialState,
  reducers: {
    setEpdState(state, action) {
      state.totalQuantityPiles = action.payload.totalQuantityPiles;
      state.headConstruction = action.payload.headConstruction;
      state.titanSustain = action.payload.titanSustain;
    },
    setHeadConstruction(state, action) {
      state.headConstruction = action.payload;
    },
    setTitanSustain(state, action) {
      state.titanSustain = action.payload;
    },
    setTotalQuantityPiles(state, action) {
      state.totalQuantityPiles = action.payload;
    },
    setGwpValues(state, action) {
      state.gwpValues = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (state, action) => {
      return initialState;
    });
  },
});

export const {
  setEpdState,
  setHeadConstruction,
  setTitanSustain,
  setTotalQuantityPiles,
  setGwpValues,
} = epdSlice.actions;

export const selectEpdState = (state) => state.epd;
export const selectGwpValues = (state) => state.epd.gwpValues;
export const selectHeadConstruction = (state) => state.epd.headConstruction;
export const selectTitanSustain = (state) => state.epd.titanSustain;
export const selectTotalQuantityPiles = (state) => state.epd.totalQuantityPiles;

export default epdSlice.reducer;

export const selectEdp = createSelector(
  [
    (state) => state.fhwa,
    selectGwpValues,
    selectHeadConstruction,
    selectTitanSustain,
    selectTotalQuantityPiles,
  ],
  (state, gwpValues, headConstruction, titanSustain, totalQuantityPiles) => {
    // only use state if there is no specific select
    return {
      gwpValues: gwpValues,
      headConstruction: headConstruction,
      titanSustain: titanSustain,
      totalQuantityPiles: totalQuantityPiles,
    };
  }
);
